function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P3Consumes = function P3Consumes(_ref) {
  var page = _ref.page;
  var thisPage = 5;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      $('.p3-consumes').addClass('p3-consumes__active');
      $('.p3-consumes-m').addClass('p3-consumes-m__active');
      $('.p3-line1').addClass('p3-line1__active');
      $('.p3-line2').addClass('p3-line2__active');
      setTimeArr([setTimeout(function () {
        $('.p3-challenges').addClass('p3-challenges__active');
      }, 2000)]);
    } else {
      $('.p3-consumes').removeClass('p3-consumes__active');
      $('.p3-consumes-m').removeClass('p3-consumes-m__active');
      $('.p3-line1').removeClass('p3-line1__active');
      $('.p3-line2').removeClass('p3-line2__active');
      $('.p3-challenges').removeClass('p3-challenges__active');
    }
  }, [page]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p3/the-world-consumes@3x.png",
    className: "p3-consumes"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p3/mobile-the-world-consumes@3x.png",
    className: "p3-consumes-m"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p3/thick-line-copy-2@3x.png",
    className: "p3-line1"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p3/thick-line-copy-2@3x.png",
    className: "p3-line2"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p3/mobile-blurb-sustainability@3x.png",
    className: "p3-challenges"
  }));
};
export default P3Consumes;